import { Directive, HostListener, inject, Input, OnDestroy } from '@angular/core';

import { TooltipService } from '@services/tooltip.service';

@Directive({
  selector: '[app-tooltip]',
})
export class TooltipDirective implements OnDestroy {
  private tooltipService = inject(TooltipService);
  @Input('app-tooltip') tooltip?: string;
  @Input('tooltip-position') position: 'top' | 'bottom' = 'top';
  @Input('tooltip-z-index') zIndex: 'default' | 'max' = 'default';

  @HostListener('mouseenter', ['$event.target']) onClick(event: HTMLElement): void {
    this.tooltipService.close();
    if (this.tooltip) this.tooltipService.open(this.tooltip, event, this.position, this.zIndex);
  }

  @HostListener('mouseleave') onMouseLeave(): void {
    this.tooltipService.close();
  }

  ngOnDestroy(): void {
    this.tooltipService.close();
  }
}
